import {Button, Form, Modal} from "semantic-ui-react";
import {ILLTag} from "../../interfaces/Tag";
import {useEffect, useState} from "react";
import {useAppDispatch} from "../../app/hooks";
import {CreateNewTag, UpdateTag} from "./TablesActions";
import {RootState} from "../../app/store";
import {useSelector} from "react-redux";
import { useTranslation } from "react-i18next";
interface ITagModal {
  open: boolean;
  row: any;
  updateRow: boolean;
  onClose: () => void;
}
const defaultEmptyTag: ILLTag = {
  id: "",
  name: "",
  defaulttext: "",
  istexttag: 0,
  isbarcodetag: 0,
  isimgtag: 0,
  istechtag: 0,
  isrequired: 0,
  isprimary: 0,
  isgs1ai: 0,
  usecounter: 0,
};

export const TagModal = ({open, row, updateRow, onClose}: ITagModal) => {
  const [errors, setErrors] = useState<{[key: string]: string}>({});
  const [newRow, setNewRow] = useState<ILLTag>(defaultEmptyTag);
  const dispatch = useAppDispatch();
  const {companyId, role} = useSelector((state: RootState) => state.auth);
  const {t} = useTranslation();
  useEffect(() => {
    if (updateRow) {
      setNewRow(row);
    } else {
      setNewRow(defaultEmptyTag);
    }
  }, [row, updateRow]);

  const onInputChange = (e: any) => {
    const {name, value} = e.target;
    setErrors({...errors, [name]: ""});
    setNewRow({...newRow, [name]: value});
  };
  const onCheckBoxChange = (e: any, data: any) => {
    setErrors({...errors, tags: ""});
    setNewRow({...newRow, [data.name]: data.checked ? 1 : 0});
  };
  const validateForm = () => {
    let errors = {};

    if (newRow.id === "") {
      errors = {...errors, id: t("id_empty_err")};
    }
    if(newRow.id.startsWith("LL") && role !== "super_admin") {
      errors = {...errors, id: t("default_tag_id_err")};
    }
    if (newRow.name === "") {
      errors = {...errors, name: t("name_empty_err")};
    }
    // if (newRow.defaulttext === "") {
    //   errors = {...errors, defaulttext: "Please fill the Default text field"};
    // }
    if (newRow.istexttag === 0 && newRow.isbarcodetag === 0 && newRow.isimgtag === 0 && newRow.istechtag === 0) {
      errors = {...errors, tags: t("tag_type_err")};
    }

    setErrors(errors);

    return Object.keys(errors).length === 0;
  };

  const onSubmit = (e: any) => {
    e.preventDefault();
    if (validateForm()) {
      if (updateRow) {
        dispatch(UpdateTag(newRow, companyId));
      } else {
        dispatch(CreateNewTag(newRow, companyId));
      }
      onHide();
    }
  };
  const onHide = () => {
    setNewRow(defaultEmptyTag);
    setErrors({});
    onClose();
  };
  return (
    <Modal size="small" closeIcon onClose={onHide} open={open}>
      <Modal.Header> {!updateRow ? t("create_new_tag") : t("update_tag")}</Modal.Header>
      <Modal.Content>
        <Form onSubmit={onSubmit}>
          <Form.Field required>
            <label>{t("id")}</label>
            <Form.Input
              autoFocus
              placeholder={t("id")}
              required
              name="id"
              value={newRow.id}
              onChange={onInputChange}
              disabled={updateRow}
              error={errors.id ? {content: errors.id, pointing: "below"} : false}
            />
          </Form.Field>
          <Form.Field required>
            <label>{t("name")}</label>
            <Form.Input placeholder={t("name")} required name="name" value={newRow.name} onChange={onInputChange} error={errors.name ? {content: errors.name, pointing: "below"} : false} />
          </Form.Field>
          <Form.Field>
            <label>{t("default_text")}</label>
            <Form.Input
              placeholder={t("default_text")}
              name="defaulttext"
              value={newRow.defaulttext}
              onChange={onInputChange}
              error={errors.defaulttext ? {content: errors.defaulttext, pointing: "below"} : false}
            />
          </Form.Field>
          <Form.Group style={{display: "flex", justifyContent: "space-between"}}>
            <Form.Field error={errors.tags !== undefined && errors.tags !== ""}>
              <Form.Checkbox label={t("text_tag")} name="istexttag" checked={newRow.istexttag === 1} onChange={onCheckBoxChange} />
            </Form.Field>
            <Form.Field error={errors.tags !== undefined && errors.tags !== ""}>
              <Form.Checkbox label={t("barcode_tag")} name="isbarcodetag" checked={newRow.isbarcodetag === 1} onChange={onCheckBoxChange} />
            </Form.Field>
            <Form.Field error={errors.tags !== undefined && errors.tags !== ""}>
              <Form.Checkbox label={t("image_tag")} name="isimgtag" checked={newRow.isimgtag === 1} onChange={onCheckBoxChange} />
            </Form.Field>
            <Form.Field error={errors.tags !== undefined && errors.tags !== ""}>
              <Form.Checkbox label={t("tech_tag")} name="istechtag" checked={newRow.istechtag === 1} onChange={onCheckBoxChange} />
            </Form.Field>
          </Form.Group>
            <Form.Field error={errors.isprimary !== undefined && errors.isprimary !== ""}>
            <label>{t("additional_settings")}</label>
              <Form.Checkbox label={t("is_primary")} name="isprimary" checked={newRow.isprimary === 1} onChange={onCheckBoxChange} />
            </Form.Field>
            <Form.Field error={errors.isgs1ai !== undefined && errors.isgs1ai !== ""}>
              <Form.Checkbox label={t("is_gs1_ai")} name="isgs1ai" checked={newRow.isgs1ai === 1} onChange={onCheckBoxChange} />
            </Form.Field>
            <Form.Field error={errors.usecounter !== undefined && errors.usecounter !== ""}>
              <Form.Checkbox label={t("use_counter")} name="usecounter" checked={newRow.usecounter === 1} onChange={onCheckBoxChange} />
            </Form.Field>
            <Form.Field error={errors.isrequired !== undefined && errors.isrequired !== ""}>
              <Form.Checkbox label={t("is_required")} name="isrequired" checked={newRow.isrequired === 1} onChange={onCheckBoxChange} />
            </Form.Field>
          <button type="submit" style={{display: "none"}} aria-hidden="true"></button>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button color="black" basic onClick={onHide}>
          {t("cancel_btn")}
        </Button>
        <Button color="green" basic type="submit" onClick={onSubmit}>
          {!updateRow ? t("create_btn") : t("update_btn")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
